import { i18n } from 'app/localization/i18n';
import { useAllAddresses } from 'app/network/address';

const AMBASSADOR_SIGN_UP_URL_FR =
  'https://docs.google.com/forms/d/e/1FAIpQLSfVlfFVN1_MrzJgovyRX_69NwmZTAAhp98l7PvTr1-jL2c-FA/viewform?usp=dialog';
const AMBASSADOR_SIGN_UP_URL_OTHER =
  'https://docs.google.com/forms/d/e/1FAIpQLSezuQG-Puej9iEENFreayo3ObsCh5Tro7OeHkxgRcQkasViOQ/viewform?usp=header';

export function useAmbassadorSignUpUrl(): string {
  const lang = i18n.language;
  return lang === 'fr' ? AMBASSADOR_SIGN_UP_URL_FR : AMBASSADOR_SIGN_UP_URL_OTHER;
}

export function useAmbassadorLearnMoreUrl(): string {
  const { data: addresses } = useAllAddresses();
  const firstAddress = addresses?.[0];
  const country = firstAddress?.country?.toLowerCase().trim() ?? 'xx'; // Default to 'xx' if country is not available, which the website will handle gracefully by using the detected country
  const lang = i18n.language;
  const url = `https://www.partage.club/${lang}-${country}/app/get-involved`;
  return url;
}
